import { Box, CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Navbar } from "./Components/Navbar";
import { HeroSection } from "./Components/HeroSection";
import { FeaturesSection } from "./Components/FeaturesSection";
import { CtaSection } from "./Components/CtaSection";
import { Footer } from "./Components/Footer";

// Tema completamente diferente com tons de roxo e coral
const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#673AB7", // Roxo
      dark: "#4527A0",
      light: "#9575CD",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#FF5252", // Coral
      dark: "#D32F2F",
      light: "#FF8A80",
      contrastText: "#ffffff",
    },
    background: {
      default: "#F5F5F7",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#212121",
      secondary: "#616161",
    },
    divider: "#E0E0E0",
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 800,
      letterSpacing: "-0.02em",
    },
    h2: {
      fontWeight: 700,
      letterSpacing: "-0.01em",
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
      letterSpacing: "0.02em",
    },
  },
  shape: {
    borderRadius: 12,
  },
  // shadows: [
  //   "none",
  //   "0px 2px 8px rgba(0, 0, 0, 0.08)",
  //   "0px 4px 16px rgba(0, 0, 0, 0.08)",
  //   "0px 6px 24px rgba(0, 0, 0, 0.1)",
  //   "0px 8px 32px rgba(0, 0, 0, 0.12)",
  //   // ... resto dos shadows padrão
  // ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 30,
          padding: "10px 24px",
          boxShadow: "0 4px 14px 0 rgba(0,0,0,0.12)",
        },
        contained: {
          "&:hover": {
            boxShadow: "0 6px 20px 0 rgba(0,0,0,0.2)",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
  },
});

export const LandingPages0003 = () => {
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          backgroundColor: theme.palette.background.default,
        }}
      >
        <CssBaseline />
        <Navbar
          specialistName="Carlos Saúde"
          specialistTitle="Especialista em Planos de Saúde"
          avatarSrc="https://via.placeholder.com/40"
        />
        <HeroSection />
        <FeaturesSection />
        <CtaSection />
        <Footer />
      </Box>
    </ThemeProvider>
  );
};
